const EMPTY_OPERATORS = [];

export const getOperators = (state) => {
  return state.operators?.data || EMPTY_OPERATORS;
};

export const getOperatorsLoading = (state) => {
  return state.operators?.loadedAt === null;
};

export const getOperatorsLoadedAt = (state) => {
  return state.operators?.loadedAt;
};
